import * as React from 'react';
export const CWSvg = React.forwardRef(function CWSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#43458B',
      d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#FCD669',
      d: 'M0 9.5h16V11H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F6F9FC',
      d: 'M4.92 5.51h-.74a.1.1 0 0 1-.1-.07l-.22-.7a.1.1 0 0 0-.2 0l-.22.7a.1.1 0 0 1-.1.07H2.6a.1.1 0 0 0-.06.19l.6.43a.1.1 0 0 1 .03.11l-.22.7a.1.1 0 0 0 .16.12l.59-.4a.1.1 0 0 1 .12 0l.6.4a.1.1 0 0 0 .15-.12l-.22-.7a.1.1 0 0 1 .03-.11l.6-.43a.1.1 0 0 0-.06-.19ZM2.8 3.63h-.54a.08.08 0 0 1-.07-.05L2 3.05a.08.08 0 0 0-.14 0l-.17.53a.08.08 0 0 1-.07.05h-.55a.08.08 0 0 0-.05.14l.45.32c.02.02.03.05.02.09l-.17.52a.08.08 0 0 0 .12.08l.45-.3a.08.08 0 0 1 .09 0l.44.3a.08.08 0 0 0 .12-.08l-.17-.52a.08.08 0 0 1 .03-.09l.44-.32a.08.08 0 0 0-.04-.14Z',
    }),
  );
});
CWSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var CW = {
  category: 'flag',
  colorable: false,
  name: 'CW',
  svg: CWSvg,
};
